import { api } from "./api";

export const FaqApi = (params) => {
  return api.get("/distributor/faq/faq-list", JSON.stringify(params));
};
